import { Actions } from "vuex-smart-module";
import axios from "@/web_client/axios_config";

import TargetsState from "./state";
import TargetsMutations from "./mutations";
import TargetsGetters from "./getters";
import Urls from "@/web_client/urls";
import { MutationTypes } from "../mutations-types";

const targetsUrl = Urls.aisUrls;

export default class TargetsActions extends Actions<
  TargetsState,
  TargetsGetters,
  TargetsMutations,
  TargetsActions
> {
  getAtons() {
    axios.get(targetsUrl.atons).then((response) => {
      this.commit(MutationTypes.SET_ATONS, response.data);
    });
  }
  getBaseStations(){
    axios.get(targetsUrl.basestations).then((response) => {
        this.commit(MutationTypes.SET_BS, response.data);
      });
  }
}
